import "./AccountSettingsEdit.scss";
import React, {useState} from "react";


import {DatePicker, Form, Input} from "antd";
import moment from "moment/moment";
import dayjs from "dayjs";
import {useTranslation} from "react-i18next";
import useAppSelector from "../../../hooks/useAppSelector";
import useAppDispatch from "../../../hooks/useAppDispatch";
import {openMessage} from "../../../store/notification/notificationSlice";
import {IChangePasswordModel, IModelForUpdateCustomer} from "../../../models/Auth";
import {updateProfileAction} from "../../../store/profile/profileSlice";
import {AuthService} from "../../../services/auth.service";
import CustomButton from "../../../components/UI/CustomButton/CustomButton";


const AccountSettingsEdit = () => {
    const {profile} = useAppSelector(state => state.profileSlice);
    const [newPasswordValue, setNewPasswordValue] = useState<string>("");
    const [confirmPasswordValue, setConfirmPasswordValue] = useState<string>("");
    const {t} = useTranslation();

    const dispatch = useAppDispatch();

    const onFinish = async (values: { email: string, phone: string, dateOfBirth: any }) => {
        if (!profile) return;
        const model: IModelForUpdateCustomer = {
            ...values,
            dateOfBirth: dayjs(values.dateOfBirth).toString(),
            id: profile?.customerId
        }

        const response = await AuthService.updateProfile(model);

        if (response.status === 200) {
            dispatch(openMessage({title: t("ProfileUpdated"), type: "success"}));
            dispatch(updateProfileAction(model));
        } else {
            dispatch(openMessage({title: t("SomethingWentWrong"), type: "error"}));
        }
    };


    const config = {
        rules: [{required: true}],
    };

    const onChangePassword = async () => {
        if (!profile) return;

        if (newPasswordValue !== confirmPasswordValue) {
            dispatch(openMessage({title: t("PasswordsMustMatch"), type: "error"}))
            return
        }

        if (newPasswordValue.length < 6) {
            dispatch(openMessage({title: t("PasswordMustBeLonger"), type: "error"}))
            return;
        }

        const model: IChangePasswordModel = {
            confirmPassword: confirmPasswordValue,
            password: newPasswordValue,
            profileId: profile?.id
        }

        const response = await AuthService.changePassword(model);

        if (response.status === 200) {
            dispatch(openMessage({title: t("PasswordChangedSuccessfully"), type: "success"}));
        } else {
            dispatch(openMessage({title: t("SomethingWentWrong"), type: "error"}));
        }
        setConfirmPasswordValue("");
        setNewPasswordValue("");
    }

    return (
        <div className="container">
            {profile && <>
                <section className="account-settings-edit-section">
                    <Form
                        className="form"
                        name="edit-profile"
                        initialValues={{
                            dateOfBirth: profile.dateOfBirth ? dayjs(profile.dateOfBirth) : null,
                            email: profile.email,
                            phone: profile.phone
                        }}
                        onFinish={onFinish}
                    >

                        <div className="account-settings-box">
                            <div className="card">
                                <h3 className="title">{t("PersonalInformation")}</h3>

                                <div className="card-wrapper">

                                    <Form.Item
                                        className="card-item form-item"
                                        label={t("Email")}
                                        name="email"
                                        rules={[{required: true}]}
                                    >
                                        <Input className="form-item__input"
                                               placeholder={t("PleaseInputYourEmailAddress")}
                                               disabled={true}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        className="card-item form-item"
                                        label={t("Phone")}
                                        name="phone"
                                        rules={[{required: true}]}
                                    >
                                        <Input className="form-item__input"
                                               placeholder={t("PleaseInputYourPhone")}/>
                                    </Form.Item>

                                    <Form.Item
                                        className="card-item form-item"
                                        label={t("DateOfBirth")}
                                        name="dateOfBirth"
                                        {...config}
                                    >
                                        <DatePicker
                                            format="DD/MM/YYYY"
                                            className="form-item__datepicker"
                                            placeholder="DD/MM/YYYY"
                                        />
                                    </Form.Item>

                                    <div className="card-item joined">
                                        <h4 className="card-item__title">
                                            {t("Joined")}
                                        </h4>
                                        <p className="card-item__info">
                                            {moment(profile.createdAt).format("DD/MM/YYYY")}
                                        </p>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div className="account-settings-box">
                            <div className="password-wrapper">
                                <h3 className="password-wrapper__title">
                                    {t("Password")}
                                </h3>
                                <div className="password-wrapper__row">
                                    <div className="password-input__wrapper">
                                        <label>
                                            {t("NewPassword")}
                                        </label>
                                        <Input.Password
                                            className="password-input"
                                            onChange={(event) => {
                                                setNewPasswordValue(event.target.value);
                                            }}
                                            value={newPasswordValue}
                                            placeholder={t("EnterNewPassword")}
                                        />
                                    </div>
                                    <div className="password-input__wrapper">
                                        <label>
                                            {t("ConfirmPassword")}
                                        </label>
                                        <Input.Password
                                            className="password-input"
                                            onChange={(event) => {
                                                setConfirmPasswordValue(event.target.value);
                                            }}
                                            value={confirmPasswordValue}
                                            placeholder={t("PleaseConfirmYourPassword")}
                                            status={newPasswordValue !== confirmPasswordValue && confirmPasswordValue !== "" ? "error" : ""}
                                        />
                                    </div>
                                    <div className="btn-wrapper-password">

                                        <CustomButton
                                            text={t("ChangePassword")}
                                            type={"button"}
                                            typeStyle={"fill"}
                                            borderRadius={false}
                                            functionOnClick={onChangePassword}
                                        />

                                    </div>

                                </div>
                            </div>

                        </div>

                        <div className={"btn-wrapper-changes"}>
                            <CustomButton
                                text={t("SaveChanges")}
                                type={"submit"}
                                typeStyle={"fill"}
                                borderRadius={false}
                            />
                        </div>


                    </Form>
                </section>


            </>}
        </div>
    )
}

export default AccountSettingsEdit;